<template>
  <el-drawer
    :modal="true"
    :modal-append-to-body="true"
    :title="title"
    :visible.sync="show"
    :close-on-click-modal="false"
    :direction="direction"
    :show-close="true"
    :close-on-press-escape="true"
    :before-close="clickCancel"
    class="add_team_dialog"
    :wrapperClosable="false"
		:with-header="false">
		<header>
  		<span><i></i>{{title}}</span>
  		<div class="btn">
  			<el-button @click="clickCancel">取消</el-button>
      	<el-button type="primary" @click="submitForm('newTeamForm')">保存</el-button>
  		</div>
  	</header>
    <el-form :model="newTeamForm" :rules="rules" ref="newTeamForm" class="newTeamForm">
      <div class="dialog_head">
        <el-form-item prop="teamName" label="小组名称">
          <el-input v-model.trim="newTeamForm.teamName" autocomplete="off" placeholder="请输入小组名称" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item prop="teamSlogan" label="小组标语">
          <el-input v-model.trim="newTeamForm.teamSlogan" autocomplete="off" placeholder="请输入小组标语" maxlength="20"></el-input>
        </el-form-item>
      </div>
      <div class="dialog_content">
        <h2>小组成员<p>注：支持一人多岗，不支持多人一岗，请确保所有岗位均有成员担任，否则系统将提示“岗位不匹配”。</p></h2>
        <div class="table_wrap">
          <el-row :gutter="20" style="margin:0">
            <el-col :span="10" class="table_box table_box1">
              <div class="search_student">
                <span>待选</span>
                <el-input v-model.trim="noChoice" placeholder="请输入学号和姓名" @keyup.enter.native="getTeamStudent"></el-input>
              </div>
              <el-table
                ref="studentTable"
                :key="tableKey"
                :row-key="getRowKey"
                :data="studentList"
                fit
                highlight-current-row
                @selection-change="handleStudentChange"
                :height="pageTotal.total>10?275:330"
                header-cell-class-name="tableHead"
              >
                <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
                <el-table-column label="姓名" align="center" prop="studentName" width="95"></el-table-column>
                <el-table-column label="学号" align="center">
                  <template slot-scope="{row}">
                    <span>{{ row.jobNumber }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageTotal.currentPage"
                background
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageTotal.pageSize"
                :pager-count="5"
                layout="sizes, prev, pager, next"
                :total="pageTotal.total"
                class="paginator"
                v-if="pageTotal.total>10"
                style="width:380px"
              ></el-pagination>
            </el-col>
            <el-col :span="2" style="text-align:center;">
              <el-button
                @click="addStudent"
                type="primary"
                :disabled="!studentData.length"
                icon="el-icon-arrow-right"
                circle
                style="margin-top: 110px;"
              ></el-button>
              <el-button
                @click="removeStudent"
                type="primary"
                :disabled="!selectedStudentData.length"
                icon="el-icon-arrow-left"
                circle
                style="margin-left: 0;margin-top: 10px;"
              ></el-button>
            </el-col>
            <el-col :span="12" class="table_box">
                <el-table
                  ref="selectedStudentTable"
                  :key="tableKey"
                  :row-key="getRowKey"
                  :data="selectedStudentList"
                  fit
                  highlight-current-row
                  @selection-change="handleSelectedStudentChange"
                  :height="height"
                  header-cell-class-name="tableHead"
                >
                  <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
                  <el-table-column label="姓名" align="center" prop="studentName" width="65"></el-table-column>
                  <el-table-column label="学号" align="center">
                    <template slot-scope="{row}">
                      <span>{{ row.jobNumber }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="岗位分配" align="center">
                    <template slot-scope="{row}">
                      <el-select class="filter-item" placeholder="请选择" v-model="row.postId" multiple >
                        <el-option
                          v-for="item in postOption"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        </div>
      </div>
    </el-form>
  </el-drawer>
</template>
<script>
import Pagination from "../../../paginator/paginator.vue";
import * as api from "../../../../api/individualApi";
export default {
  props: {
    title: {
      type: String,
      default: '标题'
    },
    editGroupForm: {
      type: Object,
      default: function(){
        return {
          teamName: '',
          teamSlogan: ''
        }
      }
    },
    classId: {
      type: Number,
      default: ''
    },
    courseId: {
      type: Number,
      default: ''
    },
    subjectId: {
      type: Number,
      default: ''
    },
    groupId: {
      type: Number,
      default: ''
    },
    showModalconfirm:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      show:false,
      newTeamForm:{
        teamName:'',
        teamSlogan:'加油'
      },
      rules: {
        teamName: [
          { required: true, message: '请输入小组名称', trigger: 'blur' },
          // { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        teamSlogan:[
          { required: true, message: '请输入小组标语', trigger: 'change' }
        ],
      },
      noChoice:'',
      studentList: [],
      selectedStudentList: [],
      studentData: [],
      selectedStudentData: [],
      tableKey: 0,
      rowKey: "rowKey",
      pageTotal: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      postOption:[], //岗位列表
      direction: 'rtl',
      height: window.innerHeight - 240+"px",
    }
  },
  components:{Pagination},
  created() {
  	console.log(this.subjectId);
  },
  methods: {
    getPostList(){//获取岗位
      let that = this
    	api.getPostList(that.subjectId).then(rs=>{
        if(rs.code==0){
          // that.postOption = rs.data
        }else{
          that.$messageError(rs.msg)
        }
      }).then(()=>{
        api.courseStation(that.$route.query.courseId).then(res=>{
          if(res.code==0){
            that.postOption = res.data
          }else{
            that.$messageError(res.msg)
          }
        })
      }).catch(err=>{
        console.log(err)
      })
    },
    getTeamStudent(){
      let obj = {};
      let request
      if(this.noChoice == ''){
        obj = {
          "classId": this.classId,
          "courseId": this.courseId,
          "deptId": sessionStorage.getItem('deptId'),
          "limit": this.pageTotal.pageSize,
          "page": this.pageTotal.currentPage
        }
        request = api.getTeamPage(obj)
      }else{
        obj = {
          "classId": this.classId,
          "courseId": this.courseId,
          "deptId": sessionStorage.getItem('deptId'),
          "limit": this.pageTotal.pageSize,
          "page": this.pageTotal.currentPage,
          "param": this.noChoice
        }
        request = api.getTeamUser(obj)
      }
      request.then(rs=>{
        if(rs.code==0){
          this.pageTotal = {
            currentPage: rs.data.pageNum,
            pageSize: rs.data.pageSize,
            total: rs.data.total
          }
          let arr = rs.data.list;
          if(this.selectedStudentList.length>0){
            this.selectedStudentList.forEach(val=>{
              arr.forEach((v,i)=>{
                if(val.studentUserId == v.studentUserId){
                  arr.splice(i, 1);
                }
              })
            })
          }
          this.studentList = arr;
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getAddTeamStudent(){
      this.newTeamForm = {
        teamName: this.editGroupForm.teamName,
        teamSlogan: this.editGroupForm.teamSlogan
      }
      api.getAddTeamStudent(this.groupId).then(rs=>{
        if(rs.code==0){
          this.selectedStudentList = []
          rs.data.forEach(val=>{
            let arr = []
            val.stations.forEach(v=>{
              arr.push(v.stationId)
            })
            let obj = {
              studentName: val.studentName,
              studentUserId: val.studentUserId,
              jobNumber: val.jobNumber,
              // postId: val.stations[0].stationId
              postId: arr
            }
            this.selectedStudentList.push(obj)
          })
        }else{
          this.$messageError(rs.data.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getRowKey(row){
      return row.id
    },
    clickCancel(){
      this.show = false
      this.$emit('cancelAddGroup')
      this.resetForm('newTeamForm')
    },
    submitForm(formName){
      this.$refs[formName].validate((valid, formdata) => {
        if (valid) {
          let isEmpty = false;
          let arr = []
          this.selectedStudentList.forEach(item => {
            if (item.postId.length==0) {
              isEmpty = true;
              return;
            }
            item.postId.forEach(v=>{
              arr.push(v)
            })
          });
          if (isEmpty) {
            this.$messageWarning("请选择岗位");
            return
          }
          if(this.selectedStudentList.length>this.postOption.length){
            this.$messageWarning("人数过多");
            return
          }
          let postArr = []
          this.postOption.forEach(v=>[
            postArr.push(v.id)
          ])
          if(JSON.stringify(arr.sort())==JSON.stringify(postArr.sort())){
            this.$emit('confirmAddGroup',this.newTeamForm,this.selectedStudentList);
          }else{
            this.$messageWarning("岗位不匹配");
            return
          }
        }else{
          console.log('error')
          return false
        }
      })
    },
    resetFormFn(){
      this.resetForm('newTeamForm')
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.selectedStudentList = []
      this.noChoice = ""
      this.$refs["studentTable"].clearSelection();
      this.$refs["selectedStudentTable"].clearSelection();
    },
    // 将左边表格选择项存入studentData中
    handleStudentChange(rows) {
      this.studentData = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.studentData.push(row);
          }
        });
      }
    },
    // 左边表格选择项移到右边
    addStudent() {
     let timer = setTimeout(() => {
        this.$refs["studentTable"].clearSelection();
        this.$refs["selectedStudentTable"].clearSelection();
        clearTimeout(timer)
      }, 0);
      let repeat = false;
      this.selectedStudentList.forEach(item => {
        if (this.studentData[0] && item.studentUserId === this.studentData[0].studentUserId) {
          repeat = true;
          return;
        }
      });
      if (repeat === false) {
        this.studentData.forEach(item => {
          this.selectedStudentList.push(item);
        });
        for (let i = 0; i < this.studentList.length; i++) {
          for (let j = 0; j < this.studentData.length; j++) {
            if (
              this.studentList[i] &&
              this.studentData[j] &&
              this.studentList[i].id === this.studentData[j].id
            ) {
              this.studentList.splice(i, 1);
            }
          }
        }
      }
    },
    // 右边表格选择项移到左边
    removeStudent() {
      let timer = setTimeout(() => {
        this.$refs["studentTable"].clearSelection();
        this.$refs["selectedStudentTable"].clearSelection();
        clearTimeout(timer)
      }, 0);
      if(this.title=='创建小组'){
        this.selectedStudentData.forEach(item => {
          this.studentList.push(item);
        });
      }
      for (let i = 0; i < this.selectedStudentList.length; i++) {
        for (let j = 0; j < this.selectedStudentData.length; j++) {
          if(this.title=='创建小组'){
            if (this.selectedStudentList[i].id === this.selectedStudentData[j].id) {
              this.selectedStudentList.splice(i, 1);
            }
          }else{
          	if (this.selectedStudentList[i].studentUserId === this.selectedStudentData[j].studentUserId) {
              this.selectedStudentList.splice(i, 1);
            }
          }
        }
        this.getTeamStudent();
      }
    },
    // 将右边表格选择项存入selectedStudentData中
    handleSelectedStudentChange(rows) {
      this.selectedStudentData = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectedStudentData.push(row);
          }
        });
      }
    },
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val;
      this.getTeamStudent()
    },
    handleSizeChange(val){
      this.pageTotal.currentPage = 1;
    	this.pageTotal.pageSize = val;
      this.getTeamStudent()
    }
  },
  watch:{
    showModalconfirm(val){
      this.show = val
      if(val){
        this.getPostList()
        this.getTeamStudent()
        if(this.title=='编辑小组'){
          this.getAddTeamStudent()
        }else{
          this.newTeamForm = {
            teamName:'',
            teamSlogan:'加油'
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
	@import './addTeamStyle.scss'
</style>



// WEBPACK FOOTER //
// src/components/views/TeachClass/components/addTeamDialog.vue